import { hasSecondLoanOnly } from '../utils/Operations';

export class FicoInfo {
  constructor(data = {}) {
    this.originalBalance = data?.originalBalance;
    this.saleAmount = data?.saleAmount;
    this.loanType = data?.loanType;
    this.saleDate = data?.saleDate || '1900-01-01T00:00:00';
    this.docDate = data?.docDate;
  }

  // This static method should only be used when we get data from VALUE CHECK
  static setFromValueCheck(data = {}) {
    const isSecondLoanOnly = hasSecondLoanOnly(data.loans);

    if (isSecondLoanOnly) {
      return new FicoInfo(
        {
          originalBalance: null,
          saleAmount: 0,
          loanType: null,
          saleDate: '1900-01-01T00:00:00',
          docDate: null,
        },
      );
    }

    const fico = {
      originalBalance: data.loans?.[0]?.originalBalance || null,
      saleAmount: data.sales?.[0]?.saleAmount || 0,
      loanType: data.loans?.[0]?.type || null,
      saleDate: data.sales?.[0]?.saleDate || '1900-01-01T00:00:00',
      docDate: data.loans?.[0]?.docDate || null,
    };

    return new FicoInfo(fico);
  }
}
